import { createFileRoute } from "@tanstack/react-router";
import { blockingImportSourcesLoader } from "src/util/query_client";
import LoadingOverlay from "src/components/LoadingOverlay";
import { ImportPage } from "@/components/imports/ImportPage";
import { ErrorBoundary } from "@/components/ErrorBoundary";

function ImportPageWithErrorBoundary() {
  return (
    <ErrorBoundary>
      <ImportPage />
    </ErrorBoundary>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const Route = createFileRoute("/_app/import")({
  component: ImportPageWithErrorBoundary,
  staticData: {
    title: "Import",
  },
  loader: async () => {
    return await blockingImportSourcesLoader();
  },
  pendingComponent: () => <LoadingOverlay isLoading={true} />,
});
